import React, { FC } from 'react'
import { TFunction } from 'i18next'
import { FormSubmitHandler } from 'redux-form'

// types
import { IFormItemData } from '../../../types/interfaces'

// components
import InputElementForm from '../../../components/forms/formBuilderElements/InputElementForm'
import ButtonElementForm from '../../../components/forms/formBuilderElements/ButtonElementForm'
import ParagraphElementForm from '../../../components/forms/formBuilderElements/ParagraphElementForm'
import TitleElementForm from '../../../components/forms/formBuilderElements/TitleElementForm'
import TextAreaElementForm from '../../../components/forms/formBuilderElements/TextAreaElementForm'
import HorizontalLineElementForm from '../../../components/forms/formBuilderElements/HorizontalLineElementForm'
import DateElementForm from '../../../components/forms/formBuilderElements/DateElementForm'
import DropdownButtonElementForm from '../../../components/forms/formBuilderElements/DropdownButtonElementForm'
import CheckBoxElementForm from '../../../components/forms/formBuilderElements/CheckBoxElementForm'
import RadioButtonElementForm from '../../../components/forms/formBuilderElements/RadioButtonElementForm'
import ImageElementForm from '../../../components/forms/formBuilderElements/ImageElementForm'
import TableElementForm from '../../../components/forms/formBuilderElements/TableElementForm'
import SelectFromTableElementForm from '../../../components/forms/formBuilderElements/SelectFromTableElementForm'
import TabBoxElementForm from '../../../components/forms/formBuilderElements/TabBoxElementForm'

// utils
import { ELEMENT_TYPES } from '../../../utils/enums'

export type ComponentProps = {
	onRemoveItem: Function
}

type Props = {
	t: TFunction
	selectedItemType: string
	handleElementFormSubmit: FormSubmitHandler<IFormItemData, ComponentProps, string>
	onRemoveItem: Function
	priorities: string[]
}

const ItemProperties: FC<Props> = (props) => {
	const { selectedItemType, handleElementFormSubmit, onRemoveItem, priorities } = props

	const renderForm = (type: string) => {
		switch (type) {
			case ELEMENT_TYPES.INPUT:
				return <InputElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.BUTTON:
				return <ButtonElementForm priorities={priorities} onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.TEXT:
				return <ParagraphElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.TITLE:
				return <TitleElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.TEXT_AREA:
				return <TextAreaElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.HORIZONTAL_LINE:
				return <HorizontalLineElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.DATE_PICKER:
				return <DateElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.DROPDOWN_BUTTON:
				return <DropdownButtonElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.CHECK_BOX:
				return <CheckBoxElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.RADIO_BUTTON:
				return <RadioButtonElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.IMAGE:
				return <ImageElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.TABLE:
				return <TableElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.SELECT_FROM_TABLE:
				return <SelectFromTableElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			case ELEMENT_TYPES.TAB_BOX:
				return <TabBoxElementForm onSubmit={handleElementFormSubmit} onRemoveItem={onRemoveItem} />
			default:
				return undefined
		}
	}

	return <div>{renderForm(selectedItemType || '')}</div>
}

export default React.memo(ItemProperties)
